import { CreativeStatusEnum } from 'features/direct/creative/components/CreativeForm/CreativeForm.values';
import gql from 'graphql-tag';
import {
  CreativeAudioLegacy,
  CreativeImageLegacy,
  CreativeRedirectLegacy,
} from 'interfaces/generated.types';

export interface ICreativeImage extends Omit<CreativeImageLegacy, 'status'> {
  status: CreativeStatusEnum;
}

export interface ICreativeAudio extends Omit<CreativeAudioLegacy, 'status'> {
  status: CreativeStatusEnum;
}

export interface ICreativeAudioFormValues extends ICreativeAudio {
  file?: {
    type: string;
  };
  type?: string;
}

export interface ICreativeRedirect
  extends Omit<CreativeRedirectLegacy, 'id' | 'altId' | 'url'> {
  id: string | null;
  altId: number | null;
  url: string | null;
}

export const GET_ALL_AUDIO_CREATIVES = gql`
  query AllAudioCreativesLegacy(
    $advertiserId: ID
    $filter: CreativeFilterLegacy
    $territories: [Territory!]!
  ) {
    allCreativesLegacy(
      advertiserId: $advertiserId
      type: AUDIO
      filter: $filter
      territories: $territories
    ) {
      ... on CreativeAudioLegacy {
        id
        name
        fileName
        url
        status
        duration
        mimeType
        uploadedDate
        resourceAltId
        altId
        advertiser {
          id
          name
        }
        territory
      }
    }
  }
`;

export const GET_ALL_IMAGE_CREATIVES = gql`
  query AllImageCreativesLegacy(
    $advertiserId: ID
    $filter: CreativeFilterLegacy
    $territories: [Territory!]!
  ) {
    allCreativesLegacy(
      advertiserId: $advertiserId
      type: IMAGE
      filter: $filter
      territories: $territories
    ) {
      ... on CreativeImageLegacy {
        id
        name
        fileName
        url
        size
        mimeType
        status
        uploadedDate
        resourceAltId
        altId
        advertiser {
          id
          name
        }
        territory
      }
    }
  }
`;

export const GENERATE_CREATIVE_URL = gql`
  query GeneratePresignedUrl(
    $contentType: String
    $fileName: String!
    $fileSize: Long
    $httpMethod: HttpMethod!
  ) {
    generatePreSignedUrl(
      attributes: {
        contentType: $contentType
        fileName: $fileName
        fileSize: $fileSize
        httpMethod: $httpMethod
      }
    ) {
      url
      assetUrl
      contentType
      uploadedDate
    }
  }
`;
